// RADAR RESIDENCIAL · CONTROLES DE VISTA (R3/R4) — selección personal de personas, modo de
// cartera y orden visual. NO toca la densidad (el selector 4/8/16/32/Todos vive donde ya vivía).
// Son preferencias de PRESENTACIÓN: no cambian roles, asignación de casos ni ownership.
import { SlidersHorizontal, X, Star } from "lucide-react";
import { ORDENES_RES, MODOS_RES } from "@/lib/radar/ordenRes";

function Opcion({ activo, onClick, children, testId, title }) {
  return (
    <button type="button" data-testid={testId} onClick={onClick} aria-pressed={activo} title={title}
      className={`min-h-9 rounded-lg px-2.5 text-[13px] font-bold transition-colors ${activo ? "bg-white text-[#012472] shadow-sm" : "text-slate-500 hover:text-[#012472]"}`}>
      {children}
    </button>
  );
}

export default function VistaControlesRes({ prefs, onPref, editando, onEditar, favoritos, conCaso, persistente }) {
  return (
    <div data-testid="radar-res-controles"
      className="flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-slate-100 px-4 py-2 sm:px-5">
      <div className="flex min-w-0 items-center gap-1.5">
        <span className="hidden shrink-0 text-[10px] font-bold uppercase tracking-wider text-slate-400 lg:inline">Cartera</span>
        <div data-testid="radar-res-modo" className="inline-flex items-center gap-0.5 rounded-xl bg-slate-100 p-0.5">
          {MODOS_RES.map((m) => (
            <Opcion key={m.v} activo={prefs.modo === m.v} onClick={() => onPref({ modo: m.v })}
              testId={`radar-res-modo-${m.v}`}
              title={m.v === "mi_vista" ? "Sólo las personas que elegiste"
                : m.v === "con_caso" ? "Sólo personas con al menos un caso abierto"
                  : "Toda la cartera autorizada"}>
              {m.t}{m.v === "mi_vista" ? ` · ${favoritos}` : m.v === "con_caso" ? ` · ${conCaso}` : ""}
            </Opcion>
          ))}
        </div>
      </div>

      <div className="flex min-w-0 items-center gap-1.5">
        <span className="hidden shrink-0 text-[10px] font-bold uppercase tracking-wider text-slate-400 lg:inline">Orden</span>
        <div data-testid="radar-res-orden" className="inline-flex items-center gap-0.5 rounded-xl bg-slate-100 p-0.5">
          {ORDENES_RES.map((o) => (
            <Opcion key={o.v} activo={prefs.orden === o.v} onClick={() => onPref({ orden: o.v })}
              testId={`radar-res-orden-${o.v}`}
              title={o.v === "prioridad" ? "Prioridad operativa resuelta por el sistema (orden inicial)" : `Orden visual por ${o.t.toLowerCase()}`}>
              {o.t}
            </Opcion>
          ))}
        </div>
      </div>

      <button type="button" data-testid="radar-res-editar-vista" onClick={onEditar}
        className={`inline-flex min-h-9 items-center gap-1.5 rounded-xl border px-2.5 text-[13px] font-bold transition-colors ${editando ? "border-[#01CBE3] bg-[#01CBE3]/10 text-[#0891A6]" : "border-slate-200 bg-white text-[#012472] hover:border-[#01CBE3]"}`}>
        {editando ? <X className="h-3.5 w-3.5" /> : <SlidersHorizontal className="h-3.5 w-3.5" />}
        {editando ? "Terminar selección" : "Editar mi vista"}
      </button>

      {editando && (
        <p data-testid="radar-res-editar-ayuda" className="flex items-center gap-1.5 text-[11px] font-semibold text-[#0891A6]">
          <Star className="h-3.5 w-3.5" /> Toca la estrella de cada tarjeta para añadirla o quitarla de tu vista
        </p>
      )}
      {!persistente && (
        <p className="text-[11px] text-slate-400">
          Tus preferencias no se pueden guardar en este navegador (el Radar sigue funcionando)
        </p>
      )}
    </div>
  );
}
